import './DetailItem.css';

import { IonCol, IonIcon, IonItem, IonRow, IonText } from '@ionic/react';

interface Props {
    icon: string,
    title: string,
    link: string
}

const DetailItem: React.FC<Props> = (props) => {
    return (
        <IonItem button routerLink={props.link} className="profile-detail-item" lines="none">
            <IonRow>
                <IonCol size="2">
                    <IonIcon className="icon" icon={props.icon} />
                </IonCol>
                <IonCol size="10">
                    <div>
                        <IonText className="title">{props.title}</IonText>
                    </div>
                </IonCol>
            </IonRow>
            {/* <IonIcon className="go" src={chevronBackOutline}/> */}
        </IonItem>
    )
}

export default DetailItem